export default {"src":"/_next/static/media/outlet-location-map-marker.502c67b4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};